import React from "react";
import { LogoProps } from "./types";
import classNames from "classnames";
import { logo } from "../../consts/logo";
import useAppSizeControl from "../../utils/useAppSizeControl";
import { Button } from "../Button/Button";
import { IconModelEnum } from "../../enum/Button/iconButton.model";
import { VarianButtonEnum } from "../../enum/Button/variantButton.model";
import useWindowSize from "../../utils/useWindowSize";

let app = document.querySelector("#volvoTrucksConfiguratorApp") as HTMLElement;

export const Logo = React.memo(({
  children,
  paddingLeftAndRight,
  paddingTopAndBottom,
  width,
  height
}: LogoProps) => {
  const [isLogoHidden, setIsLogoHidden] = useAppSizeControl(app);
  const { windowWidth } = useWindowSize();
  const isDesktop = windowWidth >= 840;

  document.querySelectorAll(".top-banner").forEach((selector) => {
    const topBanner = selector as HTMLElement;
    if (topBanner) {
      topBanner.style.zIndex = "2147483647";
    }
  });

  const volvoHeader = document.querySelector(
    ".header"
  ) as HTMLElement;
  if (!volvoHeader) {
    if (isLogoHidden) {
      setIsLogoHidden(false);
    }
  }
  else{
    volvoHeader.style.zIndex = "2147483647";
  }

  function onClickEvent() {
    app = document.querySelector("#volvoTrucksConfiguratorApp") as HTMLElement;
    
    if (app === undefined){
      app = document.querySelector("#volvoTrucksConfiguratorApp") as HTMLElement;
    }
    
    if (app) {
      app.style.position = "";
      app.style.top = "";
      app.style.left = "";
      app.style.width = "";
      app.style.height = "";
      app.style.bottom = "";
      app.style.right = "";
      app.style.zIndex = "";
      app.style.overflowY = "";

      const volvoHeader = document.querySelector(
        ".header"
      ) as HTMLElement;
      if (volvoHeader) {
        volvoHeader.style.display = "";
      }

      window.scrollTo({ top: 0, behavior: "smooth" });
      setIsLogoHidden(true); 
    }
  }

  return !isLogoHidden ? (
    <>
      {isDesktop ? (
        <button 
          className={classNames(paddingLeftAndRight, paddingTopAndBottom, width, height, "cursor-pointer logo block")}
          onClick={onClickEvent}
          aria-label="Volvo Logo - Click to return to top"
          tabIndex={0}
        >
          {typeof children === "undefined" ? logo.Default : children}
        </button>
      ) : (
        <div className="block -ml-1">
          <Button 
            ariaLabel="Volvo Logo - Click to return to top"
            icon={IconModelEnum.CLOSE_GREY}
            onClickEvent={onClickEvent}
            variant={VarianButtonEnum.ICONBUTTON}
            customClassNames="bg-light-grey-light hover:bg-light-grey-hover !p-1"
            tabIndex={0}
          />
        </div>
      )}
    </>
  ) : <div />;
});

Logo.displayName = "Logo";
